/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Reside Admission
 * Reside admission micro-service
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
import * as url from "url";
import * as portableFetch from "portable-fetch";
const BASE_PATH = "//localhost:8082/".replace(/\/+$/, "");
/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
/**
 * @export
 * @namespace Admission
 */
export var Admission;
(function (Admission) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        StatusEnum["CANCELLED"] = "CANCELLED";
        StatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        StatusEnum["SIGNED"] = "SIGNED";
        StatusEnum["APPROVED"] = "APPROVED";
        StatusEnum["ARCHIVED"] = "ARCHIVED";
        StatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(StatusEnum = Admission.StatusEnum || (Admission.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let WorkflowTypeEnum;
    (function (WorkflowTypeEnum) {
        WorkflowTypeEnum["ADMISSION"] = "admission";
        WorkflowTypeEnum["ARBITRATION"] = "arbitration";
        WorkflowTypeEnum["ADMISSION_SPANISH"] = "admission_spanish";
        WorkflowTypeEnum["READMISSION"] = "readmission";
        WorkflowTypeEnum["READMISSION_SPANISH"] = "readmission_spanish";
        WorkflowTypeEnum["FINANCIAL_PACKET"] = "financial_packet";
        WorkflowTypeEnum["FINANCIAL_PACKET_SPANISH"] = "financial_packet_spanish";
        WorkflowTypeEnum["ADMISSION_CONSERVATOR"] = "admission_conservator";
        WorkflowTypeEnum["ADMISSION_CONSERVATOR_SPANISH"] = "admission_conservator_spanish";
        WorkflowTypeEnum["ARBITRATION_SPANISH"] = "arbitration_spanish";
        WorkflowTypeEnum["PENDING"] = "pending";
    })(WorkflowTypeEnum = Admission.WorkflowTypeEnum || (Admission.WorkflowTypeEnum = {}));
})(Admission || (Admission = {}));
/**
 * @export
 * @namespace AdmissionFileReference
 */
export var AdmissionFileReference;
(function (AdmissionFileReference) {
    /**
     * @export
     * @enum {string}
     */
    let PccUploadStatusEnum;
    (function (PccUploadStatusEnum) {
        PccUploadStatusEnum["SUCCESS"] = "SUCCESS";
        PccUploadStatusEnum["PENDING"] = "PENDING";
        PccUploadStatusEnum["ERROR"] = "ERROR";
    })(PccUploadStatusEnum = AdmissionFileReference.PccUploadStatusEnum || (AdmissionFileReference.PccUploadStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["ADMISSION"] = "ADMISSION";
        TypeEnum["PHOTO"] = "PHOTO";
        TypeEnum["TEMPLATE"] = "TEMPLATE";
        TypeEnum["PICTURE"] = "PICTURE";
        TypeEnum["VARIABLE"] = "VARIABLE";
        TypeEnum["ANSWER"] = "ANSWER";
        TypeEnum["PROTECTED"] = "PROTECTED";
        TypeEnum["USER_IMPORT"] = "USER_IMPORT";
        TypeEnum["USER_EXPORT"] = "USER_EXPORT";
    })(TypeEnum = AdmissionFileReference.TypeEnum || (AdmissionFileReference.TypeEnum = {}));
})(AdmissionFileReference || (AdmissionFileReference = {}));
/**
 * @export
 * @namespace AdmissionNote
 */
export var AdmissionNote;
(function (AdmissionNote) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["NEW"] = "NEW";
        StatusEnum["RESOLVED"] = "RESOLVED";
        StatusEnum["CANCELLED"] = "CANCELLED";
    })(StatusEnum = AdmissionNote.StatusEnum || (AdmissionNote.StatusEnum = {}));
})(AdmissionNote || (AdmissionNote = {}));
/**
 * @export
 * @namespace AdmissionNotificationModel
 */
export var AdmissionNotificationModel;
(function (AdmissionNotificationModel) {
    /**
     * @export
     * @enum {string}
     */
    let ChannelEnum;
    (function (ChannelEnum) {
        ChannelEnum["EMAIL"] = "EMAIL";
        ChannelEnum["SMS"] = "SMS";
    })(ChannelEnum = AdmissionNotificationModel.ChannelEnum || (AdmissionNotificationModel.ChannelEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["EMERGENCY_CONTACT_INVITATION"] = "EMERGENCY_CONTACT_INVITATION";
        TypeEnum["STAFF_ACCOUNT_CREATED"] = "STAFF_ACCOUNT_CREATED";
        TypeEnum["STAFF_ACCOUNT_CREATED_FOR_RESIDE_ADMIN"] = "STAFF_ACCOUNT_CREATED_FOR_RESIDE_ADMIN";
        TypeEnum["RESET_PASSWORD"] = "RESET_PASSWORD";
        TypeEnum["ADMISSION_IN_PROGRESS"] = "ADMISSION_IN_PROGRESS";
        TypeEnum["ADMISSION_APPROVED_RESIDENT"] = "ADMISSION_APPROVED_RESIDENT";
        TypeEnum["ADMISSION_APPROVED_REPRESENTATIVE"] = "ADMISSION_APPROVED_REPRESENTATIVE";
        TypeEnum["ADMISSION_CANCELLATION"] = "ADMISSION_CANCELLATION";
        TypeEnum["ADMISSION_UPLOADED_TO_PCC"] = "ADMISSION_UPLOADED_TO_PCC";
        TypeEnum["RESIDENT_DEACTIVATED"] = "RESIDENT_DEACTIVATED";
        TypeEnum["ADMISSION_DOCUMENTS_REMINDER_FOR_RESIDENT"] = "ADMISSION_DOCUMENTS_REMINDER_FOR_RESIDENT";
        TypeEnum["ADMISSION_DOCUMENTS_REMINDER_FOR_CLERK"] = "ADMISSION_DOCUMENTS_REMINDER_FOR_CLERK";
        TypeEnum["APPLY_FOR_MEDICARE"] = "APPLY_FOR_MEDICARE";
        TypeEnum["ADVANCED_DIRECTIVE_INFORMATION"] = "ADVANCED_DIRECTIVE_INFORMATION";
        TypeEnum["LAUNDRY_SERVICES_REQUEST"] = "LAUNDRY_SERVICES_REQUEST";
        TypeEnum["ASSIGN_HEALTHCARE_SURROGATE"] = "ASSIGN_HEALTHCARE_SURROGATE";
        TypeEnum["SUPPLEMENTAL_INSURANCE_INFORMATION_REQUEST"] = "SUPPLEMENTAL_INSURANCE_INFORMATION_REQUEST";
        TypeEnum["ADMISSION_SIGNED"] = "ADMISSION_SIGNED";
        TypeEnum["TRUST_FOUND_POLICY_DISAGREEMENT"] = "TRUST_FOUND_POLICY_DISAGREEMENT";
        TypeEnum["SUPPLEMENT_C_DISAGREEMENT"] = "SUPPLEMENT_C_DISAGREEMENT";
        TypeEnum["ARBITRATION_AGREEMENT_NOT_ACCEPTED"] = "ARBITRATION_AGREEMENT_NOT_ACCEPTED";
        TypeEnum["FUNERAL_HOME_NOT_ACCEPTED"] = "FUNERAL_HOME_NOT_ACCEPTED";
        TypeEnum["ADMISSION_DOCUMENTS_REMINDER_FOR_RESIDENT_REPRESENTATIVE"] = "ADMISSION_DOCUMENTS_REMINDER_FOR_RESIDENT_REPRESENTATIVE";
        TypeEnum["FACILITY_STAFF_AFTER_SENT_TO_RESIDENT"] = "FACILITY_STAFF_AFTER_SENT_TO_RESIDENT";
        TypeEnum["ADMISSION_ENTRY_LINK"] = "ADMISSION_ENTRY_LINK";
        TypeEnum["BCBSIL_PACKAGE"] = "BCBSIL_PACKAGE";
        TypeEnum["PCC_API_DAILY_QUOTA_EXCEEDED"] = "PCC_API_DAILY_QUOTA_EXCEEDED";
        TypeEnum["ALTERNATIVE_DISPUTE_RESOLUTION_AGREEMENT_NOT_ACCEPTED"] = "ALTERNATIVE_DISPUTE_RESOLUTION_AGREEMENT_NOT_ACCEPTED";
        TypeEnum["COVID_RIDER_NOT_ACCEPTED"] = "COVID_RIDER_NOT_ACCEPTED";
    })(TypeEnum = AdmissionNotificationModel.TypeEnum || (AdmissionNotificationModel.TypeEnum = {}));
})(AdmissionNotificationModel || (AdmissionNotificationModel = {}));
/**
 * @export
 * @namespace AdmissionStatusTransition
 */
export var AdmissionStatusTransition;
(function (AdmissionStatusTransition) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        StatusEnum["CANCELLED"] = "CANCELLED";
        StatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        StatusEnum["SIGNED"] = "SIGNED";
        StatusEnum["APPROVED"] = "APPROVED";
        StatusEnum["ARCHIVED"] = "ARCHIVED";
        StatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(StatusEnum = AdmissionStatusTransition.StatusEnum || (AdmissionStatusTransition.StatusEnum = {}));
})(AdmissionStatusTransition || (AdmissionStatusTransition = {}));
/**
 * @export
 * @namespace AnswerOfobject
 */
export var AnswerOfobject;
(function (AnswerOfobject) {
    /**
     * @export
     * @enum {string}
     */
    let QuestionTypeEnum;
    (function (QuestionTypeEnum) {
        QuestionTypeEnum["TEXT"] = "TEXT";
        QuestionTypeEnum["DATE"] = "DATE";
        QuestionTypeEnum["DATETIME"] = "DATETIME";
        QuestionTypeEnum["CHECKBOX"] = "CHECKBOX";
        QuestionTypeEnum["RADIO"] = "RADIO";
        QuestionTypeEnum["SELECT"] = "SELECT";
        QuestionTypeEnum["STATE_SELECT"] = "STATE_SELECT";
        QuestionTypeEnum["SIGNATURE"] = "SIGNATURE";
        QuestionTypeEnum["IMAGE"] = "IMAGE";
        QuestionTypeEnum["TEXTAREA"] = "TEXTAREA";
        QuestionTypeEnum["OBJECT"] = "OBJECT";
        QuestionTypeEnum["LIST"] = "LIST";
        QuestionTypeEnum["FILE"] = "FILE";
        QuestionTypeEnum["CURRENCY"] = "CURRENCY";
        QuestionTypeEnum["TIMEZONE_SELECT"] = "TIMEZONE_SELECT";
    })(QuestionTypeEnum = AnswerOfobject.QuestionTypeEnum || (AnswerOfobject.QuestionTypeEnum = {}));
})(AnswerOfobject || (AnswerOfobject = {}));
/**
 * @export
 * @namespace Approval
 */
export var Approval;
(function (Approval) {
    /**
     * @export
     * @enum {string}
     */
    let ApproverTitleEnum;
    (function (ApproverTitleEnum) {
        ApproverTitleEnum["ADMISSIONS_FINANCIAL_SPECIALIST"] = "ADMISSIONS_FINANCIAL_SPECIALIST";
        ApproverTitleEnum["ADMISSIONS_DIRECTOR"] = "ADMISSIONS_DIRECTOR";
        ApproverTitleEnum["FINANCIAL_COORDINATOR"] = "FINANCIAL_COORDINATOR";
        ApproverTitleEnum["ADMINISTRATOR"] = "ADMINISTRATOR";
        ApproverTitleEnum["SOCIAL_SERVICES_DIRECTOR"] = "SOCIAL_SERVICES_DIRECTOR";
        ApproverTitleEnum["LIAISON"] = "LIAISON";
        ApproverTitleEnum["BUSINESS_OFFICE_MANAGER"] = "BUSINESS_OFFICE_MANAGER";
        ApproverTitleEnum["EXECUTIVE_DIRECTOR"] = "EXECUTIVE_DIRECTOR";
        ApproverTitleEnum["LICENSEE"] = "LICENSEE";
        ApproverTitleEnum["GENERAL_MANAGER"] = "GENERAL_MANAGER";
        ApproverTitleEnum["FACILITY_REPRESENTATIVE"] = "FACILITY_REPRESENTATIVE";
    })(ApproverTitleEnum = Approval.ApproverTitleEnum || (Approval.ApproverTitleEnum = {}));
})(Approval || (Approval = {}));
/**
 * @export
 * @namespace ChecklistItem
 */
export var ChecklistItem;
(function (ChecklistItem) {
    /**
     * @export
     * @enum {string}
     */
    let CheckedStatusEnum;
    (function (CheckedStatusEnum) {
        CheckedStatusEnum["OPEN"] = "OPEN";
        CheckedStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        CheckedStatusEnum["COMPLETED"] = "COMPLETED";
        CheckedStatusEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    })(CheckedStatusEnum = ChecklistItem.CheckedStatusEnum || (ChecklistItem.CheckedStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let MandatoryForStatusesEnum;
    (function (MandatoryForStatusesEnum) {
        MandatoryForStatusesEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        MandatoryForStatusesEnum["CANCELLED"] = "CANCELLED";
        MandatoryForStatusesEnum["IN_PROGRESS"] = "IN_PROGRESS";
        MandatoryForStatusesEnum["SIGNED"] = "SIGNED";
        MandatoryForStatusesEnum["APPROVED"] = "APPROVED";
        MandatoryForStatusesEnum["ARCHIVED"] = "ARCHIVED";
        MandatoryForStatusesEnum["INCOMPLETE"] = "INCOMPLETE";
    })(MandatoryForStatusesEnum = ChecklistItem.MandatoryForStatusesEnum || (ChecklistItem.MandatoryForStatusesEnum = {}));
})(ChecklistItem || (ChecklistItem = {}));
/**
 * @export
 * @namespace PageableDto
 */
export var PageableDto;
(function (PageableDto) {
    /**
     * @export
     * @enum {string}
     */
    let DirectionEnum;
    (function (DirectionEnum) {
        DirectionEnum["ASC"] = "ASC";
        DirectionEnum["DESC"] = "DESC";
    })(DirectionEnum = PageableDto.DirectionEnum || (PageableDto.DirectionEnum = {}));
})(PageableDto || (PageableDto = {}));
/**
 * @export
 * @namespace ParametersDto
 */
export var ParametersDto;
(function (ParametersDto) {
    /**
     * @export
     * @enum {string}
     */
    let StatusesEnum;
    (function (StatusesEnum) {
        StatusesEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        StatusesEnum["CANCELLED"] = "CANCELLED";
        StatusesEnum["IN_PROGRESS"] = "IN_PROGRESS";
        StatusesEnum["SIGNED"] = "SIGNED";
        StatusesEnum["APPROVED"] = "APPROVED";
        StatusesEnum["ARCHIVED"] = "ARCHIVED";
        StatusesEnum["INCOMPLETE"] = "INCOMPLETE";
    })(StatusesEnum = ParametersDto.StatusesEnum || (ParametersDto.StatusesEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let WorkflowTypeEnum;
    (function (WorkflowTypeEnum) {
        WorkflowTypeEnum["ADMISSION"] = "admission";
    })(WorkflowTypeEnum = ParametersDto.WorkflowTypeEnum || (ParametersDto.WorkflowTypeEnum = {}));
})(ParametersDto || (ParametersDto = {}));
/**
 * @export
 * @namespace PartialPdfReference
 */
export var PartialPdfReference;
(function (PartialPdfReference) {
    /**
     * @export
     * @enum {string}
     */
    let PccUploadStatusEnum;
    (function (PccUploadStatusEnum) {
        PccUploadStatusEnum["SUCCESS"] = "SUCCESS";
        PccUploadStatusEnum["PENDING"] = "PENDING";
        PccUploadStatusEnum["ERROR"] = "ERROR";
    })(PccUploadStatusEnum = PartialPdfReference.PccUploadStatusEnum || (PartialPdfReference.PccUploadStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["ADMISSION"] = "ADMISSION";
        TypeEnum["PHOTO"] = "PHOTO";
        TypeEnum["TEMPLATE"] = "TEMPLATE";
        TypeEnum["PICTURE"] = "PICTURE";
        TypeEnum["VARIABLE"] = "VARIABLE";
        TypeEnum["ANSWER"] = "ANSWER";
        TypeEnum["PROTECTED"] = "PROTECTED";
        TypeEnum["USER_IMPORT"] = "USER_IMPORT";
        TypeEnum["USER_EXPORT"] = "USER_EXPORT";
    })(TypeEnum = PartialPdfReference.TypeEnum || (PartialPdfReference.TypeEnum = {}));
})(PartialPdfReference || (PartialPdfReference = {}));
/**
 * @export
 * @namespace PatchAdmissionDto
 */
export var PatchAdmissionDto;
(function (PatchAdmissionDto) {
    /**
     * @export
     * @enum {string}
     */
    let WorkflowTypeEnum;
    (function (WorkflowTypeEnum) {
        WorkflowTypeEnum["ADMISSION"] = "admission";
        WorkflowTypeEnum["ARBITRATION"] = "arbitration";
        WorkflowTypeEnum["ADMISSION_SPANISH"] = "admission_spanish";
        WorkflowTypeEnum["READMISSION"] = "readmission";
        WorkflowTypeEnum["READMISSION_SPANISH"] = "readmission_spanish";
        WorkflowTypeEnum["FINANCIAL_PACKET"] = "financial_packet";
        WorkflowTypeEnum["FINANCIAL_PACKET_SPANISH"] = "financial_packet_spanish";
        WorkflowTypeEnum["ADMISSION_CONSERVATOR"] = "admission_conservator";
        WorkflowTypeEnum["ADMISSION_CONSERVATOR_SPANISH"] = "admission_conservator_spanish";
        WorkflowTypeEnum["ARBITRATION_SPANISH"] = "arbitration_spanish";
        WorkflowTypeEnum["PENDING"] = "pending";
    })(WorkflowTypeEnum = PatchAdmissionDto.WorkflowTypeEnum || (PatchAdmissionDto.WorkflowTypeEnum = {}));
})(PatchAdmissionDto || (PatchAdmissionDto = {}));
/**
 * @export
 * @namespace Pcc
 */
export var Pcc;
(function (Pcc) {
    /**
     * @export
     * @enum {string}
     */
    let RelatedAdmissionStatusEnum;
    (function (RelatedAdmissionStatusEnum) {
        RelatedAdmissionStatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        RelatedAdmissionStatusEnum["CANCELLED"] = "CANCELLED";
        RelatedAdmissionStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        RelatedAdmissionStatusEnum["SIGNED"] = "SIGNED";
        RelatedAdmissionStatusEnum["APPROVED"] = "APPROVED";
        RelatedAdmissionStatusEnum["ARCHIVED"] = "ARCHIVED";
        RelatedAdmissionStatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(RelatedAdmissionStatusEnum = Pcc.RelatedAdmissionStatusEnum || (Pcc.RelatedAdmissionStatusEnum = {}));
})(Pcc || (Pcc = {}));
/**
 * @export
 * @namespace PccActivityLogDto
 */
export var PccActivityLogDto;
(function (PccActivityLogDto) {
    /**
     * @export
     * @enum {string}
     */
    let ErrorCodeEnum;
    (function (ErrorCodeEnum) {
        ErrorCodeEnum["ACCOUNT"] = "MISSING_PATIENT_ACCOUNT";
    })(ErrorCodeEnum = PccActivityLogDto.ErrorCodeEnum || (PccActivityLogDto.ErrorCodeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let EventTypeEnum;
    (function (EventTypeEnum) {
        EventTypeEnum["CREATE_PATIENT"] = "CREATE_PATIENT";
        EventTypeEnum["UPLOAD_DOCUMENT"] = "UPLOAD_DOCUMENT";
        EventTypeEnum["UPLOAD_ADMISSION_PACKET"] = "UPLOAD_ADMISSION_PACKET";
        EventTypeEnum["EVENT_LISTENER_ACTIVATE_MAPPING"] = "EVENT_LISTENER_ACTIVATE_MAPPING";
        EventTypeEnum["EVENT_LISTENER_DELETE_MAPPING"] = "EVENT_LISTENER_DELETE_MAPPING";
        EventTypeEnum["UPLOAD_INDIVIDUAL_DOCUMENT"] = "UPLOAD_INDIVIDUAL_DOCUMENT";
    })(EventTypeEnum = PccActivityLogDto.EventTypeEnum || (PccActivityLogDto.EventTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["SUCCESS"] = "SUCCESS";
        StatusEnum["FAILED"] = "FAILED";
        StatusEnum["SKIPPED"] = "SKIPPED";
        StatusEnum["PENDING"] = "PENDING";
    })(StatusEnum = PccActivityLogDto.StatusEnum || (PccActivityLogDto.StatusEnum = {}));
})(PccActivityLogDto || (PccActivityLogDto = {}));
/**
 * @export
 * @namespace PccSyncDto
 */
export var PccSyncDto;
(function (PccSyncDto) {
    /**
     * @export
     * @enum {string}
     */
    let EventTypeEnum;
    (function (EventTypeEnum) {
        EventTypeEnum["PendingPatientAccepted"] = "patient.pendingPatientAccepted";
        EventTypeEnum["Admit"] = "patient.admit";
        EventTypeEnum["Readmit"] = "patient.readmit";
        EventTypeEnum["PreAdmit"] = "patient.preAdmit";
    })(EventTypeEnum = PccSyncDto.EventTypeEnum || (PccSyncDto.EventTypeEnum = {}));
})(PccSyncDto || (PccSyncDto = {}));
/**
 * @export
 * @namespace ResidentDetailDto
 */
export var ResidentDetailDto;
(function (ResidentDetailDto) {
    /**
     * @export
     * @enum {string}
     */
    let GenderEnum;
    (function (GenderEnum) {
        GenderEnum["MALE"] = "MALE";
        GenderEnum["FEMALE"] = "FEMALE";
        GenderEnum["UNKNOWN"] = "UNKNOWN";
    })(GenderEnum = ResidentDetailDto.GenderEnum || (ResidentDetailDto.GenderEnum = {}));
})(ResidentDetailDto || (ResidentDetailDto = {}));
/**
 * @export
 * @namespace ResidentDto
 */
export var ResidentDto;
(function (ResidentDto) {
    /**
     * @export
     * @enum {string}
     */
    let GenderEnum;
    (function (GenderEnum) {
        GenderEnum["MALE"] = "MALE";
        GenderEnum["FEMALE"] = "FEMALE";
        GenderEnum["UNKNOWN"] = "UNKNOWN";
    })(GenderEnum = ResidentDto.GenderEnum || (ResidentDto.GenderEnum = {}));
})(ResidentDto || (ResidentDto = {}));
/**
 * AdmissionDocumentControllerApi - fetch parameter creator
 * @export
 */
export const AdmissionDocumentControllerApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Full administrator view of an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdmissionUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling adminAdmissionUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/administration`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Approve an admission
         * @param {Admission} body admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAdmissionUsingPATCH(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling approveAdmissionUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling approveAdmissionUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/approve`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "Admission" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Archive an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAdmissionUsingPATCH(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling archiveAdmissionUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/archive`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates admission flag within the admission
         * @param {AdmissionFlag} body admissionFlag
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmissionFlagUsingPOST(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling createAdmissionFlagUsingPOST.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling createAdmissionFlagUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/flags`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "AdmissionFlag" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new admission
         * @param {Admission} body admissionData
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmissionUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling createAdmissionUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "Admission" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete admission flag
         * @param {string} admissionId admissionId
         * @param {string} flagId flagId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling deleteAdmissionFlagUsingDELETE.");
            }
            // verify required parameter 'flagId' is not null or undefined
            if (flagId === null || flagId === undefined) {
                throw new RequiredError("flagId", "Required parameter flagId was null or undefined when calling deleteAdmissionFlagUsingDELETE.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/flags/{flagId}`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)))
                .replace(`{${"flagId"}}`, encodeURIComponent(String(flagId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel an admission
         * @param {AdmissionCancellationDto} body admissionCancellationDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmissionUsingPATCH(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling deleteAdmissionUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling deleteAdmissionUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/delete`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "AdmissionCancellationDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Process discharged PCC resident webhook
         * @param {PccDischargeResidentDto} body pccDischargeResidentDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dischargeResidentPccUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling dischargeResidentPccUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/discharge-resident-pcc`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "PccDischargeResidentDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Download generated PDF of given admission based on download or access token
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [authorization] Authorization Header
         * @param {string} [accessToken] accessToken
         * @param {string} [token] token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling downloadPartialPdfFromS3UsingGET.");
            }
            // verify required parameter 'groupKey' is not null or undefined
            if (groupKey === null || groupKey === undefined) {
                throw new RequiredError("groupKey", "Required parameter groupKey was null or undefined when calling downloadPartialPdfFromS3UsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/download-pdf/{groupKey}`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)))
                .replace(`{${"groupKey"}}`, encodeURIComponent(String(groupKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter["accessToken"] = accessToken;
            }
            if (token !== undefined) {
                localVarQueryParameter["token"] = token;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Download generated PDF of given admission based on download or access token
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {string} [accessToken] accessToken
         * @param {string} [token] token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling downloadPdfFromS3UsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/download-pdf`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter["accessToken"] = accessToken;
            }
            if (token !== undefined) {
                localVarQueryParameter["token"] = token;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get all admission flags
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionFlagsUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling getAdmissionFlagsUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/flags`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an admission without postprocessing for internal calls
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionInternalUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling getAdmissionInternalUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/internal`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get all admission status transitions
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionTransitionsUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling getAdmissionTransitionsUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/transitions`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling getAdmissionUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve preview for admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling getPreviewUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/preview`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update admissions
         * @param {AdmissionMigrationDto} body admissionMigrationDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAdmissionsTemplateUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling migrateAdmissionsTemplateUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/migrate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "AdmissionMigrationDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch admission with PatchAdmissionDto. RESIDENT cannot patch Answers and CompletionPercentage if admission is already SIGNED, but CLERK and ADMINISTRATOR can.
         * @param {PatchAdmissionDto} body patchAdmissionDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdmissionUsingPATCH(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling patchAdmissionUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling patchAdmissionUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "PatchAdmissionDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch checklist item identified by ID in given admission identified by its ID
         * @param {ChecklistItem} body checklistItem
         * @param {string} admissionId admissionId
         * @param {string} checklistItemId checklistItemId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling patchChecklistItemUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling patchChecklistItemUsingPATCH.");
            }
            // verify required parameter 'checklistItemId' is not null or undefined
            if (checklistItemId === null || checklistItemId === undefined) {
                throw new RequiredError("checklistItemId", "Required parameter checklistItemId was null or undefined when calling patchChecklistItemUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/checklist-items/{checklistItemId}`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)))
                .replace(`{${"checklistItemId"}}`, encodeURIComponent(String(checklistItemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "ChecklistItem" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Process admission with pending PCC account
         * @param {AdmissionWithPendingPatientDto} body admissionWithPendingPatientDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling processAdmissionWithPendingPccAccountUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/process-admission-with-pending-pcc-account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "AdmissionWithPendingPatientDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore cancelled admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAdmissionUsingPATCH(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling restoreAdmissionUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/restore`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reupload the admission PDF contract files
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reuploadContractUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling reuploadContractUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/reupload`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch admission with PatchAdmissionDto. RESIDENT can patch only Answers which are on slides marked as afterAdmission if admission is already SIGNED.
         * @param {PatchAdmissionDto} body patchAdmissionDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling saveAfterAdmissionAnswersUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling saveAfterAdmissionAnswersUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/after-admission`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "PatchAdmissionDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search admissions. Returns Page<AdmissionPreview>
         * @param {ParametersDto} body body
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdmissionUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling searchAdmissionUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "ParametersDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search admissions by query resident name or code or resident code. Returns Page<AdmissionPreview>
         * @param {string} query query
         * @param {string} [authorization] Authorization Header
         * @param {number} [page]
         * @param {number} [size]
         * @param {ReadonlyArray<string>} [sort]
         * @param {ReadonlyArray<string>} [status] status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options = {}) {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError("query", "Required parameter query was null or undefined when calling searchAdmissionsByQueryUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (query !== undefined) {
                localVarQueryParameter["query"] = query;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (status) {
                localVarQueryParameter["status"] = status;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set admission status to in-progress for the given workflow type.
         * @param {string} admissionId admissionId
         * @param {string} [workflowType] Workflow type (defaults to ADMISSION)
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling sendAdmissionToResidentUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/in-progress`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workflowType !== undefined && workflowType !== null) {
                localVarQueryParameter["workflowType"] = workflowType;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send notification for given admission
         * @param {AdmissionNotificationModel} body admissionNotificationModel
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationUsingPOST(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling sendNotificationUsingPOST.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling sendNotificationUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/notification`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "AdmissionNotificationModel" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sign an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAdmissionUsingPATCH(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling signAdmissionUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/sign`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Synchronize with PCC webhook
         * @param {PccSyncDto} body pccSyncDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWithPccUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling syncWithPccUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/sync-with-pcc`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "PccSyncDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update admission flags
         * @param {ReadonlyArray<AdmissionFlag>} body admissionFlagsData
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling updateAdmissionFlagsUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling updateAdmissionFlagsUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/flags`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "ReadonlyArray&lt;AdmissionFlag&gt;" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update admission notes
         * @param {ReadonlyArray<AdmissionNote>} body admissionNotesData
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling updateAdmissionNoteUsingPATCH.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling updateAdmissionNoteUsingPATCH.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/notes`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PATCH" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "ReadonlyArray&lt;AdmissionNote&gt;" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdmissionDocumentControllerApi - functional programming interface
 * @export
 */
export const AdmissionDocumentControllerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Full administrator view of an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdmissionUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).adminAdmissionUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Approve an admission
         * @param {Admission} body admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAdmissionUsingPATCH(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).approveAdmissionUsingPATCH(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Archive an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAdmissionUsingPATCH(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).archiveAdmissionUsingPATCH(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Creates admission flag within the admission
         * @param {AdmissionFlag} body admissionFlag
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmissionFlagUsingPOST(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).createAdmissionFlagUsingPOST(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create a new admission
         * @param {Admission} body admissionData
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmissionUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).createAdmissionUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete admission flag
         * @param {string} admissionId admissionId
         * @param {string} flagId flagId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Cancel an admission
         * @param {AdmissionCancellationDto} body admissionCancellationDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmissionUsingPATCH(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).deleteAdmissionUsingPATCH(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Process discharged PCC resident webhook
         * @param {PccDischargeResidentDto} body pccDischargeResidentDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dischargeResidentPccUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).dischargeResidentPccUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Download generated PDF of given admission based on download or access token
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [authorization] Authorization Header
         * @param {string} [accessToken] accessToken
         * @param {string} [token] token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Download generated PDF of given admission based on download or access token
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {string} [accessToken] accessToken
         * @param {string} [token] token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get all admission flags
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionFlagsUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).getAdmissionFlagsUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get an admission without postprocessing for internal calls
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionInternalUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).getAdmissionInternalUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get all admission status transitions
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionTransitionsUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).getAdmissionTransitionsUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).getAdmissionUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve preview for admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).getPreviewUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update admissions
         * @param {AdmissionMigrationDto} body admissionMigrationDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAdmissionsTemplateUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).migrateAdmissionsTemplateUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Patch admission with PatchAdmissionDto. RESIDENT cannot patch Answers and CompletionPercentage if admission is already SIGNED, but CLERK and ADMINISTRATOR can.
         * @param {PatchAdmissionDto} body patchAdmissionDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdmissionUsingPATCH(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).patchAdmissionUsingPATCH(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Patch checklist item identified by ID in given admission identified by its ID
         * @param {ChecklistItem} body checklistItem
         * @param {string} admissionId admissionId
         * @param {string} checklistItemId checklistItemId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Process admission with pending PCC account
         * @param {AdmissionWithPendingPatientDto} body admissionWithPendingPatientDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Restore cancelled admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAdmissionUsingPATCH(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).restoreAdmissionUsingPATCH(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Reupload the admission PDF contract files
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reuploadContractUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).reuploadContractUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Patch admission with PatchAdmissionDto. RESIDENT can patch only Answers which are on slides marked as afterAdmission if admission is already SIGNED.
         * @param {PatchAdmissionDto} body patchAdmissionDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Search admissions. Returns Page<AdmissionPreview>
         * @param {ParametersDto} body body
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdmissionUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).searchAdmissionUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Search admissions by query resident name or code or resident code. Returns Page<AdmissionPreview>
         * @param {string} query query
         * @param {string} [authorization] Authorization Header
         * @param {number} [page]
         * @param {number} [size]
         * @param {ReadonlyArray<string>} [sort]
         * @param {ReadonlyArray<string>} [status] status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set admission status to in-progress for the given workflow type.
         * @param {string} admissionId admissionId
         * @param {string} [workflowType] Workflow type (defaults to ADMISSION)
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send notification for given admission
         * @param {AdmissionNotificationModel} body admissionNotificationModel
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationUsingPOST(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).sendNotificationUsingPOST(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Sign an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAdmissionUsingPATCH(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).signAdmissionUsingPATCH(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Synchronize with PCC webhook
         * @param {PccSyncDto} body pccSyncDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWithPccUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).syncWithPccUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update admission flags
         * @param {ReadonlyArray<AdmissionFlag>} body admissionFlagsData
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update admission notes
         * @param {ReadonlyArray<AdmissionNote>} body admissionNotesData
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionDocumentControllerApiFetchParamCreator(configuration).updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AdmissionDocumentControllerApi - factory interface
 * @export
 */
export const AdmissionDocumentControllerApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Full administrator view of an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdmissionUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).adminAdmissionUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Approve an admission
         * @param {Admission} body admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAdmissionUsingPATCH(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).approveAdmissionUsingPATCH(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Archive an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAdmissionUsingPATCH(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).archiveAdmissionUsingPATCH(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates admission flag within the admission
         * @param {AdmissionFlag} body admissionFlag
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmissionFlagUsingPOST(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).createAdmissionFlagUsingPOST(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new admission
         * @param {Admission} body admissionData
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmissionUsingPOST(body, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).createAdmissionUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete admission flag
         * @param {string} admissionId admissionId
         * @param {string} flagId flagId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Cancel an admission
         * @param {AdmissionCancellationDto} body admissionCancellationDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmissionUsingPATCH(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).deleteAdmissionUsingPATCH(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Process discharged PCC resident webhook
         * @param {PccDischargeResidentDto} body pccDischargeResidentDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dischargeResidentPccUsingPOST(body, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).dischargeResidentPccUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Download generated PDF of given admission based on download or access token
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [authorization] Authorization Header
         * @param {string} [accessToken] accessToken
         * @param {string} [token] token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options) {
            return AdmissionDocumentControllerApiFp(configuration).downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options)(fetch, basePath);
        },
        /**
         *
         * @summary Download generated PDF of given admission based on download or access token
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {string} [accessToken] accessToken
         * @param {string} [token] token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options) {
            return AdmissionDocumentControllerApiFp(configuration).downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options)(fetch, basePath);
        },
        /**
         *
         * @summary get all admission flags
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionFlagsUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).getAdmissionFlagsUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get an admission without postprocessing for internal calls
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionInternalUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).getAdmissionInternalUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary get all admission status transitions
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionTransitionsUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).getAdmissionTransitionsUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmissionUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).getAdmissionUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve preview for admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).getPreviewUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update admissions
         * @param {AdmissionMigrationDto} body admissionMigrationDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAdmissionsTemplateUsingPOST(body, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).migrateAdmissionsTemplateUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch admission with PatchAdmissionDto. RESIDENT cannot patch Answers and CompletionPercentage if admission is already SIGNED, but CLERK and ADMINISTRATOR can.
         * @param {PatchAdmissionDto} body patchAdmissionDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdmissionUsingPATCH(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).patchAdmissionUsingPATCH(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch checklist item identified by ID in given admission identified by its ID
         * @param {ChecklistItem} body checklistItem
         * @param {string} admissionId admissionId
         * @param {string} checklistItemId checklistItemId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Process admission with pending PCC account
         * @param {AdmissionWithPendingPatientDto} body admissionWithPendingPatientDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Restore cancelled admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAdmissionUsingPATCH(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).restoreAdmissionUsingPATCH(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reupload the admission PDF contract files
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reuploadContractUsingGET(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).reuploadContractUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch admission with PatchAdmissionDto. RESIDENT can patch only Answers which are on slides marked as afterAdmission if admission is already SIGNED.
         * @param {PatchAdmissionDto} body patchAdmissionDto
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Search admissions. Returns Page<AdmissionPreview>
         * @param {ParametersDto} body body
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdmissionUsingPOST(body, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).searchAdmissionUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Search admissions by query resident name or code or resident code. Returns Page<AdmissionPreview>
         * @param {string} query query
         * @param {string} [authorization] Authorization Header
         * @param {number} [page]
         * @param {number} [size]
         * @param {ReadonlyArray<string>} [sort]
         * @param {ReadonlyArray<string>} [status] status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options) {
            return AdmissionDocumentControllerApiFp(configuration).searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set admission status to in-progress for the given workflow type.
         * @param {string} admissionId admissionId
         * @param {string} [workflowType] Workflow type (defaults to ADMISSION)
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send notification for given admission
         * @param {AdmissionNotificationModel} body admissionNotificationModel
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationUsingPOST(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).sendNotificationUsingPOST(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Sign an admission
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAdmissionUsingPATCH(admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).signAdmissionUsingPATCH(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Synchronize with PCC webhook
         * @param {PccSyncDto} body pccSyncDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWithPccUsingPOST(body, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).syncWithPccUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update admission flags
         * @param {ReadonlyArray<AdmissionFlag>} body admissionFlagsData
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update admission notes
         * @param {ReadonlyArray<AdmissionNote>} body admissionNotesData
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options) {
            return AdmissionDocumentControllerApiFp(configuration).updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options)(fetch, basePath);
        },
    };
};
/**
 * AdmissionDocumentControllerApi - object-oriented interface
 * @export
 * @class AdmissionDocumentControllerApi
 * @extends {BaseAPI}
 */
export class AdmissionDocumentControllerApi extends BaseAPI {
    /**
     *
     * @summary Full administrator view of an admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    adminAdmissionUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).adminAdmissionUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Approve an admission
     * @param {Admission} body admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    approveAdmissionUsingPATCH(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).approveAdmissionUsingPATCH(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Archive an admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    archiveAdmissionUsingPATCH(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).archiveAdmissionUsingPATCH(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Creates admission flag within the admission
     * @param {AdmissionFlag} body admissionFlag
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    createAdmissionFlagUsingPOST(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).createAdmissionFlagUsingPOST(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create a new admission
     * @param {Admission} body admissionData
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    createAdmissionUsingPOST(body, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).createAdmissionUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete admission flag
     * @param {string} admissionId admissionId
     * @param {string} flagId flagId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).deleteAdmissionFlagUsingDELETE(admissionId, flagId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Cancel an admission
     * @param {AdmissionCancellationDto} body admissionCancellationDto
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    deleteAdmissionUsingPATCH(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).deleteAdmissionUsingPATCH(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Process discharged PCC resident webhook
     * @param {PccDischargeResidentDto} body pccDischargeResidentDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    dischargeResidentPccUsingPOST(body, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).dischargeResidentPccUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Download generated PDF of given admission based on download or access token
     * @param {string} admissionId admissionId
     * @param {string} groupKey groupKey
     * @param {string} [authorization] Authorization Header
     * @param {string} [accessToken] accessToken
     * @param {string} [token] token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).downloadPartialPdfFromS3UsingGET(admissionId, groupKey, authorization, accessToken, token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Download generated PDF of given admission based on download or access token
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {string} [accessToken] accessToken
     * @param {string} [token] token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).downloadPdfFromS3UsingGET(admissionId, authorization, accessToken, token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get all admission flags
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    getAdmissionFlagsUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).getAdmissionFlagsUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get an admission without postprocessing for internal calls
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    getAdmissionInternalUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).getAdmissionInternalUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get all admission status transitions
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    getAdmissionTransitionsUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).getAdmissionTransitionsUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get an admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    getAdmissionUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).getAdmissionUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve preview for admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    getPreviewUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).getPreviewUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update admissions
     * @param {AdmissionMigrationDto} body admissionMigrationDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    migrateAdmissionsTemplateUsingPOST(body, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).migrateAdmissionsTemplateUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Patch admission with PatchAdmissionDto. RESIDENT cannot patch Answers and CompletionPercentage if admission is already SIGNED, but CLERK and ADMINISTRATOR can.
     * @param {PatchAdmissionDto} body patchAdmissionDto
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    patchAdmissionUsingPATCH(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).patchAdmissionUsingPATCH(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Patch checklist item identified by ID in given admission identified by its ID
     * @param {ChecklistItem} body checklistItem
     * @param {string} admissionId admissionId
     * @param {string} checklistItemId checklistItemId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).patchChecklistItemUsingPATCH(body, admissionId, checklistItemId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Process admission with pending PCC account
     * @param {AdmissionWithPendingPatientDto} body admissionWithPendingPatientDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).processAdmissionWithPendingPccAccountUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Restore cancelled admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    restoreAdmissionUsingPATCH(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).restoreAdmissionUsingPATCH(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Reupload the admission PDF contract files
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    reuploadContractUsingGET(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).reuploadContractUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Patch admission with PatchAdmissionDto. RESIDENT can patch only Answers which are on slides marked as afterAdmission if admission is already SIGNED.
     * @param {PatchAdmissionDto} body patchAdmissionDto
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).saveAfterAdmissionAnswersUsingPATCH(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Search admissions. Returns Page<AdmissionPreview>
     * @param {ParametersDto} body body
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    searchAdmissionUsingPOST(body, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).searchAdmissionUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Search admissions by query resident name or code or resident code. Returns Page<AdmissionPreview>
     * @param {string} query query
     * @param {string} [authorization] Authorization Header
     * @param {number} [page]
     * @param {number} [size]
     * @param {ReadonlyArray<string>} [sort]
     * @param {ReadonlyArray<string>} [status] status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).searchAdmissionsByQueryUsingGET(query, authorization, page, size, sort, status, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set admission status to in-progress for the given workflow type.
     * @param {string} admissionId admissionId
     * @param {string} [workflowType] Workflow type (defaults to ADMISSION)
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).sendAdmissionToResidentUsingPATCH(admissionId, workflowType, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send notification for given admission
     * @param {AdmissionNotificationModel} body admissionNotificationModel
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    sendNotificationUsingPOST(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).sendNotificationUsingPOST(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Sign an admission
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    signAdmissionUsingPATCH(admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).signAdmissionUsingPATCH(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Synchronize with PCC webhook
     * @param {PccSyncDto} body pccSyncDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    syncWithPccUsingPOST(body, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).syncWithPccUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update admission flags
     * @param {ReadonlyArray<AdmissionFlag>} body admissionFlagsData
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).updateAdmissionFlagsUsingPATCH(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update admission notes
     * @param {ReadonlyArray<AdmissionNote>} body admissionNotesData
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionDocumentControllerApi
     */
    updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options) {
        return AdmissionDocumentControllerApiFp(this.configuration).updateAdmissionNoteUsingPATCH(body, admissionId, authorization, options)(this.fetch, this.basePath);
    }
}
/**
 * AdmissionEntryControllerApi - fetch parameter creator
 * @export
 */
export const AdmissionEntryControllerApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Enter admission by verifying personal data
         * @param {VerificationAnswersDto} body verificationAnswers
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterAdmissionUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling enterAdmissionUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/enter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "VerificationAnswersDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate admission entry token
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAdmissionEntryTokenUsingGET(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling generateAdmissionEntryTokenUsingGET.");
            }
            const localVarPath = `/api/v3/workflows/{admissionId}/entry-token`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send email with an admission entry link
         * @param {EmailAdmissionEntryLinkDto} body entryLinkDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling sendAdmissionEntryLinkEmailUsingPOST.");
            }
            const localVarPath = `/api/v3/workflows/auth/email-login-link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "EmailAdmissionEntryLinkDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdmissionEntryControllerApi - functional programming interface
 * @export
 */
export const AdmissionEntryControllerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Enter admission by verifying personal data
         * @param {VerificationAnswersDto} body verificationAnswers
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterAdmissionUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionEntryControllerApiFetchParamCreator(configuration).enterAdmissionUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate admission entry token
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAdmissionEntryTokenUsingGET(admissionId, authorization, options) {
            const localVarFetchArgs = AdmissionEntryControllerApiFetchParamCreator(configuration).generateAdmissionEntryTokenUsingGET(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send email with an admission entry link
         * @param {EmailAdmissionEntryLinkDto} body entryLinkDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options) {
            const localVarFetchArgs = AdmissionEntryControllerApiFetchParamCreator(configuration).sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AdmissionEntryControllerApi - factory interface
 * @export
 */
export const AdmissionEntryControllerApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Enter admission by verifying personal data
         * @param {VerificationAnswersDto} body verificationAnswers
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterAdmissionUsingPOST(body, authorization, options) {
            return AdmissionEntryControllerApiFp(configuration).enterAdmissionUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate admission entry token
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAdmissionEntryTokenUsingGET(admissionId, authorization, options) {
            return AdmissionEntryControllerApiFp(configuration).generateAdmissionEntryTokenUsingGET(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send email with an admission entry link
         * @param {EmailAdmissionEntryLinkDto} body entryLinkDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options) {
            return AdmissionEntryControllerApiFp(configuration).sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options)(fetch, basePath);
        },
    };
};
/**
 * AdmissionEntryControllerApi - object-oriented interface
 * @export
 * @class AdmissionEntryControllerApi
 * @extends {BaseAPI}
 */
export class AdmissionEntryControllerApi extends BaseAPI {
    /**
     *
     * @summary Enter admission by verifying personal data
     * @param {VerificationAnswersDto} body verificationAnswers
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionEntryControllerApi
     */
    enterAdmissionUsingPOST(body, authorization, options) {
        return AdmissionEntryControllerApiFp(this.configuration).enterAdmissionUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate admission entry token
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionEntryControllerApi
     */
    generateAdmissionEntryTokenUsingGET(admissionId, authorization, options) {
        return AdmissionEntryControllerApiFp(this.configuration).generateAdmissionEntryTokenUsingGET(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send email with an admission entry link
     * @param {EmailAdmissionEntryLinkDto} body entryLinkDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdmissionEntryControllerApi
     */
    sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options) {
        return AdmissionEntryControllerApiFp(this.configuration).sendAdmissionEntryLinkEmailUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
}
/**
 * PointClickCareControllerApi - fetch parameter creator
 * @export
 */
export const PointClickCareControllerApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Checks if PointClickCare integration is enabled
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPccIntegrationStatusUsingGET(facilityId, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling checkPccIntegrationStatusUsingGET.");
            }
            const localVarPath = `/api/point-click-care/facilities/{facilityId}/integration-status`.replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Checks if PointClickCare preflight populating flow is enabled for given facility and event type
         * @param {string} eventListenerGroupType eventListenerGroupType
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options = {}) {
            // verify required parameter 'eventListenerGroupType' is not null or undefined
            if (eventListenerGroupType === null ||
                eventListenerGroupType === undefined) {
                throw new RequiredError("eventListenerGroupType", "Required parameter eventListenerGroupType was null or undefined when calling checkPreflightPopulatingFlowEnabledUsingGET.");
            }
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling checkPreflightPopulatingFlowEnabledUsingGET.");
            }
            const localVarPath = `/api/point-click-care/facilities/{facilityId}/populating-flow-status`.replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (eventListenerGroupType !== undefined) {
                localVarQueryParameter["eventListenerGroupType"] =
                    eventListenerGroupType;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check if resident has PointClickCare account
         * @param {string} admissionId admissionId
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling checkResidentPccAccountStatusUsingGET.");
            }
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling checkResidentPccAccountStatusUsingGET.");
            }
            const localVarPath = `/api/point-click-care/account-status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (admissionId !== undefined) {
                localVarQueryParameter["admissionId"] = admissionId;
            }
            if (facilityId !== undefined) {
                localVarQueryParameter["facilityId"] = facilityId;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns list of residents based on criteria
         * @param {string} birthDate birthDate
         * @param {string} facilityId facilityId
         * @param {string} firstName firstName
         * @param {string} gender gender
         * @param {string} lastName lastName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options = {}) {
            // verify required parameter 'birthDate' is not null or undefined
            if (birthDate === null || birthDate === undefined) {
                throw new RequiredError("birthDate", "Required parameter birthDate was null or undefined when calling findResidentsUsingGET.");
            }
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling findResidentsUsingGET.");
            }
            // verify required parameter 'firstName' is not null or undefined
            if (firstName === null || firstName === undefined) {
                throw new RequiredError("firstName", "Required parameter firstName was null or undefined when calling findResidentsUsingGET.");
            }
            // verify required parameter 'gender' is not null or undefined
            if (gender === null || gender === undefined) {
                throw new RequiredError("gender", "Required parameter gender was null or undefined when calling findResidentsUsingGET.");
            }
            // verify required parameter 'lastName' is not null or undefined
            if (lastName === null || lastName === undefined) {
                throw new RequiredError("lastName", "Required parameter lastName was null or undefined when calling findResidentsUsingGET.");
            }
            const localVarPath = `/api/point-click-care/residents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (birthDate !== undefined) {
                localVarQueryParameter["birthDate"] = birthDate.toISOString();
            }
            if (facilityId !== undefined) {
                localVarQueryParameter["facilityId"] = facilityId;
            }
            if (firstName !== undefined) {
                localVarQueryParameter["firstName"] = firstName;
            }
            if (gender !== undefined) {
                localVarQueryParameter["gender"] = gender;
            }
            if (lastName !== undefined) {
                localVarQueryParameter["lastName"] = lastName;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns facility based activity logs for authenticated users. Pagination is mandatory, default is page=0&size=20&sort=time,desc. Search params: ?facilityId=facilityIdentifier || ?organizationId=organizationIdentifier
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {string} [organizationId] organizationId
         * @param {number} [page]
         * @param {number} [size]
         * @param {ReadonlyArray<string>} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling getActivityLogRecordsUsingGET.");
            }
            const localVarPath = `/api/point-click-care/activity-logs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (facilityId !== undefined) {
                localVarQueryParameter["facilityId"] = facilityId;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter["organizationId"] = organizationId;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns document upload categories by facility ID
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadCategoriesUsingGET(facilityId, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling getDocumentUploadCategoriesUsingGET.");
            }
            const localVarPath = `/api/point-click-care/facilities/{facilityId}/document-upload-categories`.replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns resident by ID
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {string} [admissionId] admissionId
         * @param {number} [patientId] patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentUsingGET(facilityId, authorization, admissionId, patientId, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError("facilityId", "Required parameter facilityId was null or undefined when calling getResidentUsingGET.");
            }
            const localVarPath = `/api/point-click-care/resident`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (admissionId !== undefined) {
                localVarQueryParameter["admissionId"] = admissionId;
            }
            if (facilityId !== undefined) {
                localVarQueryParameter["facilityId"] = facilityId;
            }
            if (patientId !== undefined) {
                localVarQueryParameter["patientId"] = patientId;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create new PointClickCare account and appropriate mapping
         * @param {CreateAccountDto} body createAccountDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewPccAccountUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling requestNewPccAccountUsingPOST.");
            }
            const localVarPath = `/api/point-click-care/accounts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "CreateAccountDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retries activity specified by id
         * @param {RetryActivityDto} body retryActivityDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryActivityUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling retryActivityUsingPOST.");
            }
            const localVarPath = `/api/point-click-care/activity-logs/retry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "RetryActivityDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Skips creating PointClickCare account for specified patient/resident
         * @param {CreateAccountDto} body createAccountDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipPccAccountUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling skipPccAccountUsingPOST.");
            }
            const localVarPath = `/api/point-click-care/accounts/skipped`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "CreateAccountDto" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Uploads checklist item document to PCC
         * @param {Blob} file
         * @param {string} admissionId admissionId
         * @param {string} checklistItemId checklistItemId
         * @param {number} documentCategoryId documentCategoryId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options = {}) {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError("file", "Required parameter file was null or undefined when calling uploadChecklistItemDocumentUsingPOST.");
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling uploadChecklistItemDocumentUsingPOST.");
            }
            // verify required parameter 'checklistItemId' is not null or undefined
            if (checklistItemId === null || checklistItemId === undefined) {
                throw new RequiredError("checklistItemId", "Required parameter checklistItemId was null or undefined when calling uploadChecklistItemDocumentUsingPOST.");
            }
            // verify required parameter 'documentCategoryId' is not null or undefined
            if (documentCategoryId === null || documentCategoryId === undefined) {
                throw new RequiredError("documentCategoryId", "Required parameter documentCategoryId was null or undefined when calling uploadChecklistItemDocumentUsingPOST.");
            }
            const localVarPath = `/api/point-click-care/integrations/admissions/{admissionId}/checklist-items/{checklistItemId}/document-upload`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)))
                .replace(`{${"checklistItemId"}}`, encodeURIComponent(String(checklistItemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new url.URLSearchParams();
            if (documentCategoryId !== undefined) {
                localVarQueryParameter["documentCategoryId"] = documentCategoryId;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            if (file !== undefined) {
                localVarFormParams.set("file", file);
            }
            localVarHeaderParameter["Content-Type"] =
                "application/x-www-form-urlencoded";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Upload generated packet of given admission and store returned document identifier
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPacketUsingPUT(admissionId, authorization, options = {}) {
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError("admissionId", "Required parameter admissionId was null or undefined when calling uploadPacketUsingPUT.");
            }
            const localVarPath = `/api/point-click-care/integrations/admissions/{admissionId}`.replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Endpoint called once pending PointClickCare account gets active on PointClickCare side
         * @param {string} body payload
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webHookUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError("body", "Required parameter body was null or undefined when calling webHookUsingPOST.");
            }
            const localVarPath = `/api/point-click-care/events/process-pending-accounts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter["Authorization"] = String(authorization);
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = "string" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(body || {})
                : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PointClickCareControllerApi - functional programming interface
 * @export
 */
export const PointClickCareControllerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Checks if PointClickCare integration is enabled
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPccIntegrationStatusUsingGET(facilityId, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).checkPccIntegrationStatusUsingGET(facilityId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Checks if PointClickCare preflight populating flow is enabled for given facility and event type
         * @param {string} eventListenerGroupType eventListenerGroupType
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Check if resident has PointClickCare account
         * @param {string} admissionId admissionId
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns list of residents based on criteria
         * @param {string} birthDate birthDate
         * @param {string} facilityId facilityId
         * @param {string} firstName firstName
         * @param {string} gender gender
         * @param {string} lastName lastName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns facility based activity logs for authenticated users. Pagination is mandatory, default is page=0&size=20&sort=time,desc. Search params: ?facilityId=facilityIdentifier || ?organizationId=organizationIdentifier
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {string} [organizationId] organizationId
         * @param {number} [page]
         * @param {number} [size]
         * @param {ReadonlyArray<string>} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns document upload categories by facility ID
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadCategoriesUsingGET(facilityId, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).getDocumentUploadCategoriesUsingGET(facilityId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns resident by ID
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {string} [admissionId] admissionId
         * @param {number} [patientId] patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentUsingGET(facilityId, authorization, admissionId, patientId, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).getResidentUsingGET(facilityId, authorization, admissionId, patientId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create new PointClickCare account and appropriate mapping
         * @param {CreateAccountDto} body createAccountDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewPccAccountUsingPOST(body, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).requestNewPccAccountUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retries activity specified by id
         * @param {RetryActivityDto} body retryActivityDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryActivityUsingPOST(body, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).retryActivityUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Skips creating PointClickCare account for specified patient/resident
         * @param {CreateAccountDto} body createAccountDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipPccAccountUsingPOST(body, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).skipPccAccountUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Uploads checklist item document to PCC
         * @param {Blob} file
         * @param {string} admissionId admissionId
         * @param {string} checklistItemId checklistItemId
         * @param {number} documentCategoryId documentCategoryId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Upload generated packet of given admission and store returned document identifier
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPacketUsingPUT(admissionId, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).uploadPacketUsingPUT(admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Endpoint called once pending PointClickCare account gets active on PointClickCare side
         * @param {string} body payload
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webHookUsingPOST(body, authorization, options) {
            const localVarFetchArgs = PointClickCareControllerApiFetchParamCreator(configuration).webHookUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * PointClickCareControllerApi - factory interface
 * @export
 */
export const PointClickCareControllerApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Checks if PointClickCare integration is enabled
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPccIntegrationStatusUsingGET(facilityId, authorization, options) {
            return PointClickCareControllerApiFp(configuration).checkPccIntegrationStatusUsingGET(facilityId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Checks if PointClickCare preflight populating flow is enabled for given facility and event type
         * @param {string} eventListenerGroupType eventListenerGroupType
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options) {
            return PointClickCareControllerApiFp(configuration).checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check if resident has PointClickCare account
         * @param {string} admissionId admissionId
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options) {
            return PointClickCareControllerApiFp(configuration).checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns list of residents based on criteria
         * @param {string} birthDate birthDate
         * @param {string} facilityId facilityId
         * @param {string} firstName firstName
         * @param {string} gender gender
         * @param {string} lastName lastName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options) {
            return PointClickCareControllerApiFp(configuration).findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns facility based activity logs for authenticated users. Pagination is mandatory, default is page=0&size=20&sort=time,desc. Search params: ?facilityId=facilityIdentifier || ?organizationId=organizationIdentifier
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {string} [organizationId] organizationId
         * @param {number} [page]
         * @param {number} [size]
         * @param {ReadonlyArray<string>} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options) {
            return PointClickCareControllerApiFp(configuration).getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns document upload categories by facility ID
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadCategoriesUsingGET(facilityId, authorization, options) {
            return PointClickCareControllerApiFp(configuration).getDocumentUploadCategoriesUsingGET(facilityId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns resident by ID
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {string} [admissionId] admissionId
         * @param {number} [patientId] patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentUsingGET(facilityId, authorization, admissionId, patientId, options) {
            return PointClickCareControllerApiFp(configuration).getResidentUsingGET(facilityId, authorization, admissionId, patientId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create new PointClickCare account and appropriate mapping
         * @param {CreateAccountDto} body createAccountDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewPccAccountUsingPOST(body, authorization, options) {
            return PointClickCareControllerApiFp(configuration).requestNewPccAccountUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retries activity specified by id
         * @param {RetryActivityDto} body retryActivityDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryActivityUsingPOST(body, authorization, options) {
            return PointClickCareControllerApiFp(configuration).retryActivityUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Skips creating PointClickCare account for specified patient/resident
         * @param {CreateAccountDto} body createAccountDto
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipPccAccountUsingPOST(body, authorization, options) {
            return PointClickCareControllerApiFp(configuration).skipPccAccountUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Uploads checklist item document to PCC
         * @param {Blob} file
         * @param {string} admissionId admissionId
         * @param {string} checklistItemId checklistItemId
         * @param {number} documentCategoryId documentCategoryId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options) {
            return PointClickCareControllerApiFp(configuration).uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Upload generated packet of given admission and store returned document identifier
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPacketUsingPUT(admissionId, authorization, options) {
            return PointClickCareControllerApiFp(configuration).uploadPacketUsingPUT(admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Endpoint called once pending PointClickCare account gets active on PointClickCare side
         * @param {string} body payload
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webHookUsingPOST(body, authorization, options) {
            return PointClickCareControllerApiFp(configuration).webHookUsingPOST(body, authorization, options)(fetch, basePath);
        },
    };
};
/**
 * PointClickCareControllerApi - object-oriented interface
 * @export
 * @class PointClickCareControllerApi
 * @extends {BaseAPI}
 */
export class PointClickCareControllerApi extends BaseAPI {
    /**
     *
     * @summary Checks if PointClickCare integration is enabled
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    checkPccIntegrationStatusUsingGET(facilityId, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).checkPccIntegrationStatusUsingGET(facilityId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Checks if PointClickCare preflight populating flow is enabled for given facility and event type
     * @param {string} eventListenerGroupType eventListenerGroupType
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).checkPreflightPopulatingFlowEnabledUsingGET(eventListenerGroupType, facilityId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Check if resident has PointClickCare account
     * @param {string} admissionId admissionId
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).checkResidentPccAccountStatusUsingGET(admissionId, facilityId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns list of residents based on criteria
     * @param {string} birthDate birthDate
     * @param {string} facilityId facilityId
     * @param {string} firstName firstName
     * @param {string} gender gender
     * @param {string} lastName lastName
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).findResidentsUsingGET(birthDate, facilityId, firstName, gender, lastName, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns facility based activity logs for authenticated users. Pagination is mandatory, default is page=0&size=20&sort=time,desc. Search params: ?facilityId=facilityIdentifier || ?organizationId=organizationIdentifier
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {string} [organizationId] organizationId
     * @param {number} [page]
     * @param {number} [size]
     * @param {ReadonlyArray<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options) {
        return PointClickCareControllerApiFp(this.configuration).getActivityLogRecordsUsingGET(facilityId, authorization, organizationId, page, size, sort, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns document upload categories by facility ID
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    getDocumentUploadCategoriesUsingGET(facilityId, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).getDocumentUploadCategoriesUsingGET(facilityId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns resident by ID
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {string} [admissionId] admissionId
     * @param {number} [patientId] patientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    getResidentUsingGET(facilityId, authorization, admissionId, patientId, options) {
        return PointClickCareControllerApiFp(this.configuration).getResidentUsingGET(facilityId, authorization, admissionId, patientId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create new PointClickCare account and appropriate mapping
     * @param {CreateAccountDto} body createAccountDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    requestNewPccAccountUsingPOST(body, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).requestNewPccAccountUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retries activity specified by id
     * @param {RetryActivityDto} body retryActivityDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    retryActivityUsingPOST(body, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).retryActivityUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Skips creating PointClickCare account for specified patient/resident
     * @param {CreateAccountDto} body createAccountDto
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    skipPccAccountUsingPOST(body, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).skipPccAccountUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Uploads checklist item document to PCC
     * @param {Blob} file
     * @param {string} admissionId admissionId
     * @param {string} checklistItemId checklistItemId
     * @param {number} documentCategoryId documentCategoryId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).uploadChecklistItemDocumentUsingPOST(file, admissionId, checklistItemId, documentCategoryId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Upload generated packet of given admission and store returned document identifier
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    uploadPacketUsingPUT(admissionId, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).uploadPacketUsingPUT(admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Endpoint called once pending PointClickCare account gets active on PointClickCare side
     * @param {string} body payload
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointClickCareControllerApi
     */
    webHookUsingPOST(body, authorization, options) {
        return PointClickCareControllerApiFp(this.configuration).webHookUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
}
